enum TaskType {
  Waiver = 1,
  RentalProfile = 2,
  ChildRegistrationProfile = 3,
  Photo = 4,
}
export default TaskType
